'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var recommendation = require('@coveo/headless/recommendation');
var cn = require('classnames');
var EventEmitter = require('eventemitter3');
var headless = require('@coveo/headless');
var Highlighter = require('react-highlight-words');
var ReactDOM = require('react-dom');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cn__default = /*#__PURE__*/_interopDefaultLegacy(cn);
var EventEmitter__default = /*#__PURE__*/_interopDefaultLegacy(EventEmitter);
var Highlighter__default = /*#__PURE__*/_interopDefaultLegacy(Highlighter);
var ReactDOM__default = /*#__PURE__*/_interopDefaultLegacy(ReactDOM);

var _path$e;
function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }
function SvgCommunity(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$e({
    width: 16,
    height: 16,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$e || (_path$e = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M13.5 5c0-2.75-2.938-5-6.5-5C3.406 0 .5 2.25.5 5c0 1.094.438 2.063 1.188 2.875C1.25 8.844.563 9.594.563 9.594a.3.3 0 00-.063.281c.063.094.125.125.25.125 1.125 0 2.063-.375 2.75-.781 1 .5 2.219.781 3.5.781 3.563 0 6.5-2.219 6.5-5zm3.813 6.875C18.03 11.062 18.5 10.094 18.5 9c0-2.063-1.688-3.875-4.063-4.625.032.219.063.438.063.625 0 3.313-3.375 6-7.5 6-.344 0-.688 0-1-.031C6.969 12.75 9.281 14 12 14c1.281 0 2.469-.281 3.469-.781A5.428 5.428 0 0018.25 14c.094 0 .188-.031.219-.125s.031-.219-.063-.281c0 0-.687-.75-1.093-1.719z",
    fill: "#333"
  })));
}

var _path$d;
function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }
function SvgKnowledgeBase(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$d({
    width: 16,
    height: 16,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$d || (_path$d = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M14 11.25V.75a.76.76 0 00-.75-.75H3a3 3 0 00-3 3v10a3 3 0 003 3h10.25a.74.74 0 00.75-.75v-.5a.76.76 0 00-.281-.563c-.156-.5-.156-1.874 0-2.343A.774.774 0 0014 11.25zM4 4.187C4 4.095 4.063 4 4.188 4h6.625c.093 0 .187.094.187.188v.625c0 .125-.094.187-.188.187H4.189C4.063 5 4 4.937 4 4.812v-.625zm0 2C4 6.095 4.063 6 4.188 6h6.625c.093 0 .187.094.187.188v.625c0 .125-.094.187-.188.187H4.189C4.063 7 4 6.937 4 6.812v-.625zM11.906 14H3c-.563 0-1-.438-1-1 0-.531.438-1 1-1h8.906a10.706 10.706 0 000 2z"
  })));
}

var _path$c;
function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
function SvgTechDoc(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$c({
    width: 16,
    height: 16,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$c || (_path$c = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M14.5 11.25V.75a.76.76 0 00-.75-.75H3.5a3 3 0 00-3 3v10a3 3 0 003 3h10.25a.74.74 0 00.75-.75v-.5a.76.76 0 00-.281-.563c-.156-.5-.156-1.874 0-2.343a.774.774 0 00.281-.594zm-10-7.063c0-.093.063-.187.188-.187h6.625c.093 0 .187.094.187.188v.625c0 .125-.094.187-.188.187H4.689c-.125 0-.188-.063-.188-.188v-.625zm0 2c0-.093.063-.187.188-.187h6.625c.093 0 .187.094.187.188v.625c0 .125-.094.187-.188.187H4.689c-.125 0-.188-.063-.188-.188v-.625zM12.406 14H3.5c-.563 0-1-.438-1-1 0-.531.438-1 1-1h8.906a10.706 10.706 0 000 2z",
    fill: "#333"
  })));
}

var _a, _b;
var THEMES = {
    DARK: 'dark',
    LIGHT: 'light',
};
var VIEWS = {
    HOME: 'home',
    RESULTS: 'results-list',
    ARTICLE: 'article',
};
var RESULT_LIST_VIEW = {
    LIST: 'list',
    CARD: 'card',
};
var MODES = {
    FULLSCREEN: 'fullscreen',
    DEFAULT: 'default',
};
var COMMUNITY_SOURCE = 'LIVEcommunity';
var COMMUNITY_SOURCE_DEV = 'Live Community Dev';
var SALESFORCE_SOURCE = 'Salesforce Knowledge';
var SALESFORCE_SOURCE_STAGE = 'Salesforce Knowledge SIT';
var SALESFORCE_GCS_SOURCE = 'Salesforce - Knowledge - GCS Dev';
var TECH_DOCS_XML_SOURCE = 'PANW TechDocs XML';
var TECH_DOCS_SOURCE = 'PANW TechDocs (Fawkes)';
var TECH_DOCS_HELP_SOURCE = 'PANW TechDocs HELP';
var TECH_DOCS_XML_SOURCE_STAGE = 'PANW TechDocs Stage XML';
var TECH_DOCS_SOURCE_STAGE = 'PANW TechDocs Stage (Fawkes)';
var TECH_DOCS_HELP_SOURCE_STAGE = 'PANW TechDocs Stage HELP';
var TECH_DOCS_PAN_SOURCE = 'PAN techDOCS';
var PRISMA_CLOUD_DOCS_SOURCE = 'PANW Prisma Cloud Docs';
var PRISMA_CLOUD_DOCS_SOURCE_DEV = 'PANW Prisma Cloud Docs Dev';
var SOURCE_TITLE_MAP = (_a = {},
    _a[COMMUNITY_SOURCE] = 'LIVEcommunity',
    _a[COMMUNITY_SOURCE_DEV] = 'LIVE Community',
    _a[SALESFORCE_SOURCE] = 'Knowledge Base',
    _a[SALESFORCE_SOURCE_STAGE] = 'Knowledge Base',
    _a[SALESFORCE_GCS_SOURCE] = 'Knowledge Base',
    _a[TECH_DOCS_XML_SOURCE] = 'Technical Documentation',
    _a[TECH_DOCS_HELP_SOURCE] = 'Technical Documentation',
    _a[TECH_DOCS_SOURCE] = 'Technical Documentation',
    _a[TECH_DOCS_XML_SOURCE_STAGE] = 'Technical Documentation',
    _a[TECH_DOCS_HELP_SOURCE_STAGE] = 'Technical Documentation',
    _a[TECH_DOCS_SOURCE_STAGE] = 'Technical Documentation',
    _a[TECH_DOCS_PAN_SOURCE] = 'Technical Documentation',
    _a[PRISMA_CLOUD_DOCS_SOURCE] = 'Technical Documentation',
    _a[PRISMA_CLOUD_DOCS_SOURCE_DEV] = 'Technical Documentation',
    _a);
var SOURCE_ICON_MAP = (_b = {},
    _b[COMMUNITY_SOURCE] = SvgCommunity,
    _b[COMMUNITY_SOURCE_DEV] = SvgCommunity,
    _b[SALESFORCE_SOURCE] = SvgKnowledgeBase,
    _b[SALESFORCE_SOURCE_STAGE] = SvgKnowledgeBase,
    _b[SALESFORCE_GCS_SOURCE] = SvgKnowledgeBase,
    _b[TECH_DOCS_XML_SOURCE] = SvgTechDoc,
    _b[TECH_DOCS_HELP_SOURCE] = SvgTechDoc,
    _b[TECH_DOCS_SOURCE] = SvgTechDoc,
    _b[TECH_DOCS_XML_SOURCE_STAGE] = SvgTechDoc,
    _b[TECH_DOCS_HELP_SOURCE_STAGE] = SvgTechDoc,
    _b[TECH_DOCS_SOURCE_STAGE] = SvgTechDoc,
    _b[TECH_DOCS_PAN_SOURCE] = SvgTechDoc,
    _b[PRISMA_CLOUD_DOCS_SOURCE] = SvgTechDoc,
    _b[PRISMA_CLOUD_DOCS_SOURCE_DEV] = SvgTechDoc,
    _b);

/* eslint-disable @typescript-eslint/no-unused-vars */
var HCThemeContext = React.createContext({ theme: THEMES.LIGHT, onSetTheme: function (_theme) { } });
var HCThemeProvider = function (_a) {
    var children = _a.children, initialTheme = _a.initialTheme;
    var _b = React.useState(initialTheme || THEMES.LIGHT), theme = _b[0], setTheme = _b[1];
    var onSetTheme = function (theme) {
        setTheme(theme);
    };
    return React__default["default"].createElement(HCThemeContext.Provider, { value: { theme: theme, onSetTheme: onSetTheme } }, children);
};
var HCRouterContext = React.createContext({
    currentView: VIEWS.HOME,
    prevView: null,
    onSetCurrentView: function (_params) { },
    onSetPrevView: function (_view) { },
});
var HCRouterProvider = function (_a) {
    var children = _a.children, initialMode = _a.initialMode, initialArticle = _a.initialArticle;
    var _b = React.useState(initialArticle
        ? VIEWS.ARTICLE
        : initialMode === 'fullscreen' && !initialArticle
            ? VIEWS.RESULTS
            : VIEWS.HOME), currentView = _b[0], setCurrentView = _b[1];
    var _c = React.useState(null), prevView = _c[0], setPrevView = _c[1];
    var onSetCurrentView = function (_a) {
        var view = _a.view;
        setPrevView(currentView);
        setCurrentView(view);
    };
    var onSetPrevView = function (view) {
        setPrevView(view || currentView);
    };
    return (React__default["default"].createElement(HCRouterContext.Provider, { value: {
            currentView: currentView,
            prevView: prevView,
            onSetCurrentView: onSetCurrentView,
            onSetPrevView: onSetPrevView,
        } }, children));
};
var HCContext = React.createContext({
    currentArticle: null,
    mode: 'default',
    onSetCurrentArticle: function () { },
    onSetMode: function () { },
});
var HCProvider = function (_a) {
    var children = _a.children, initialMode = _a.initialMode, initialArticle = _a.initialArticle;
    var _b = React.useState(initialArticle || null), currentArticle = _b[0], setCurrentArticle = _b[1];
    var _c = React.useState(initialMode || 'default'), mode = _c[0], setMode = _c[1];
    var onSetCurrentArticle = function (article) {
        setCurrentArticle(article);
    };
    var onSetMode = function (mode) {
        setMode(mode);
    };
    return (React__default["default"].createElement(HCContext.Provider, { value: {
            currentArticle: currentArticle,
            mode: mode,
            onSetCurrentArticle: onSetCurrentArticle,
            onSetMode: onSetMode,
        } }, children));
};

var filterProtocol = function (uri) {
    var isAbsolute = /^(https?|ftp|file|mailto|tel):/i.test(uri);
    var isRelative = /^\//.test(uri);
    return isAbsolute || isRelative ? uri : '';
};
var _T = function (str) { return str; };

var _path$b, _circle, _circle2, _circle3;
function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
function SvgListView(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.123 60.123"
  }, props), _path$b || (_path$b = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M57.124 51.893H16.92a3 3 0 110-6h40.203a3 3 0 01.001 6zM57.124 33.062H16.92a3 3 0 110-6h40.203a3 3 0 01.001 6zM57.124 14.231H16.92a3 3 0 110-6h40.203a3 3 0 01.001 6z"
  })), _circle || (_circle = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 4.029,
    cy: 11.463,
    r: 4.029
  })), _circle2 || (_circle2 = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 4.029,
    cy: 30.062,
    r: 4.029
  })), _circle3 || (_circle3 = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 4.029,
    cy: 48.661,
    r: 4.029
  })));
}

var _path$a;
function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
function SvgCardView(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 475.082 475.082"
  }, props), _path$a || (_path$a = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M182.725 36.542H36.547c-9.9 0-18.464 3.619-25.697 10.854C3.617 54.62 0 63.192 0 73.087v109.636c0 9.897 3.617 18.464 10.85 25.693 7.232 7.236 15.796 10.854 25.697 10.854h146.178c9.9 0 18.464-3.621 25.697-10.854 7.233-7.229 10.85-15.796 10.85-25.693V73.087c0-9.895-3.617-18.464-10.85-25.692-7.233-7.237-15.8-10.853-25.697-10.853zM182.725 255.813H36.547c-9.9 0-18.464 3.621-25.697 10.852C3.617 273.896 0 282.462 0 292.358v109.636c0 9.897 3.617 18.467 10.85 25.694 7.232 7.234 15.796 10.852 25.697 10.852h146.178c9.9 0 18.464-3.617 25.697-10.852 7.233-7.228 10.85-15.797 10.85-25.694V292.358c0-9.896-3.617-18.462-10.85-25.693-7.233-7.237-15.8-10.852-25.697-10.852zM464.23 47.396c-7.225-7.238-15.797-10.854-25.694-10.854H292.355c-9.896 0-18.463 3.619-25.693 10.854-7.234 7.224-10.852 15.797-10.852 25.692v109.636c0 9.897 3.617 18.464 10.852 25.693 7.23 7.236 15.797 10.854 25.693 10.854h146.181c9.897 0 18.47-3.621 25.694-10.854 7.234-7.229 10.852-15.796 10.852-25.693V73.087c0-9.895-3.615-18.461-10.852-25.691zM438.536 255.813H292.355c-9.896 0-18.463 3.621-25.693 10.852-7.234 7.231-10.852 15.797-10.852 25.693v109.636c0 9.897 3.617 18.467 10.852 25.694 7.23 7.234 15.797 10.852 25.693 10.852h146.181c9.897 0 18.47-3.617 25.694-10.852 7.234-7.228 10.852-15.797 10.852-25.694V292.358c0-9.896-3.614-18.462-10.852-25.693-7.225-7.237-15.79-10.852-25.694-10.852z"
  })));
}

var styles$c = {"box":"SearchBox-module_box__PbRmS","dark":"SearchBox-module_dark__lwfm-","light":"SearchBox-module_light__WywUE","input-wrapper":"SearchBox-module_input-wrapper__9Do3j","advanced":"SearchBox-module_advanced__MktwS","input":"SearchBox-module_input__sO9DT","input-button":"SearchBox-module_input-button__jSpcF","is-interactive":"SearchBox-module_is-interactive__18xUy","search-box-submit-btn":"SearchBox-module_search-box-submit-btn__c-GTf","info":"SearchBox-module_info__FqJqN","suggestions":"SearchBox-module_suggestions__aa-p-","suggestions-list":"SearchBox-module_suggestions-list__4-VQX","suggestions-list-item":"SearchBox-module_suggestions-list-item__M2C39","button":"SearchBox-module_button__jhf7a","tabs":"SearchBox-module_tabs__dR8em","tabs-container":"SearchBox-module_tabs-container__7png3","tab":"SearchBox-module_tab__Wvbas","active":"SearchBox-module_active__1l3-x"};

var Tabs = function (_a) {
    var _b, _c;
    var activeTab = _a.activeTab, onChangeTab = _a.onChangeTab;
    return (React__default["default"].createElement("div", { className: styles$c.tabs, test_id: "ch-advanced-tabs", "aria-label": "tabs-container" },
        React__default["default"].createElement("div", { className: styles$c['tabs-container'], test_id: "ch-advanced-item" },
            React__default["default"].createElement("div", { className: cn__default["default"](styles$c.tab, (_b = {}, _b[styles$c.active] = activeTab === RESULT_LIST_VIEW.LIST, _b)), test_id: "btn-type-list", "aria-label": "tab-type-list", onClick: function () { return onChangeTab(RESULT_LIST_VIEW.LIST); } },
                React__default["default"].createElement(SvgListView, null),
                _T('List')),
            React__default["default"].createElement("div", { className: cn__default["default"](styles$c.tab, (_c = {}, _c[styles$c.active] = activeTab === RESULT_LIST_VIEW.CARD, _c)), test_id: "btn-type-card", "aria-label": "tab-type-card", onClick: function () { return onChangeTab(RESULT_LIST_VIEW.CARD); } },
                React__default["default"].createElement(SvgCardView, null),
                _T('Card')))));
};
var Tabs$1 = React.memo(Tabs);

var useHCActions = function () {
    var _a = React.useContext(HCRouterContext), prevView = _a.prevView, onSetCurrentView = _a.onSetCurrentView;
    var _b = React.useContext(HCContext), onSetCurrentArticle = _b.onSetCurrentArticle, mode = _b.mode;
    var goTo = function (_a) {
        var view = _a.view;
        onSetCurrentView({ view: view });
    };
    var goBack = function () {
        var viewArg = prevView;
        if (prevView === VIEWS.ARTICLE) {
            viewArg = VIEWS.HOME;
        }
        onSetCurrentView({ view: viewArg || VIEWS.HOME });
    };
    var openArticle = function (article) {
        onSetCurrentArticle(article);
        onSetCurrentView({ view: VIEWS.ARTICLE });
    };
    var closeArticle = function () {
        if (mode === MODES.FULLSCREEN) {
            onSetCurrentView({ view: VIEWS.RESULTS });
        }
        else {
            goBack();
        }
        onSetCurrentArticle(null);
    };
    return Object.freeze({
        goTo: goTo,
        goBack: goBack,
        openArticle: openArticle,
        closeArticle: closeArticle,
    });
};

var useRouterCtx = function () {
    var _a = React.useContext(HCRouterContext), currentView = _a.currentView, prevView = _a.prevView, onSetCurrentView = _a.onSetCurrentView, onSetPrevView = _a.onSetPrevView;
    return {
        currentView: currentView,
        prevView: prevView,
        onSetCurrentView: onSetCurrentView,
        onSetPrevView: onSetPrevView,
    };
};

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
var eventEmitter = new EventEmitter__default["default"]();
var Emitter = {
    on: function (event, fn) { return eventEmitter.on(event, fn); },
    once: function (event, fn) { return eventEmitter.once(event, fn); },
    off: function (event, fn) { return eventEmitter.off(event, fn); },
    emit: function (event, payload) { return eventEmitter.emit(event, payload); },
};
Object.freeze(Emitter);

var useHCCtx = function () {
    var _a = React.useContext(HCContext), currentArticle = _a.currentArticle, mode = _a.mode, onSetCurrentArticle = _a.onSetCurrentArticle, onSetMode = _a.onSetMode;
    var onSetCurrentView = React.useContext(HCRouterContext).onSetCurrentView;
    var isFullscreenMode = mode === MODES.FULLSCREEN;
    var isDefaultMode = mode === MODES.DEFAULT;
    var onSetFullscreenMode = function () {
        onSetMode(MODES.FULLSCREEN);
        if (!currentArticle) {
            onSetCurrentView({ view: VIEWS.RESULTS });
        }
        Emitter.emit('changeMode', MODES.FULLSCREEN);
    };
    var onSetDefaultMode = function () {
        onSetMode(MODES.DEFAULT);
        Emitter.emit('changeMode', MODES.DEFAULT);
    };
    return {
        isFullscreenMode: isFullscreenMode,
        isDefaultMode: isDefaultMode,
        currentArticle: currentArticle,
        mode: mode,
        onSetCurrentArticle: onSetCurrentArticle,
        onSetFullscreenMode: onSetFullscreenMode,
        onSetDefaultMode: onSetDefaultMode,
    };
};

var useThemeCtx = function () {
    var _a = React.useContext(HCThemeContext), theme = _a.theme, onSetTheme = _a.onSetTheme;
    return {
        theme: theme,
        onSetTheme: onSetTheme,
    };
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var useNormalizedList = function (_a) {
    var list = _a.list, headlessSearchEngine = _a.headlessSearchEngine;
    var mode = React.useContext(HCContext).mode;
    var normalizedList = React.useMemo(function () {
        return list.map(function (item) {
            var _a, _b, _c, _d;
            var result = __assign({}, item);
            if (mode !== MODES.FULLSCREEN) {
                if ((_a = item.raw) === null || _a === void 0 ? void 0 : _a.source) {
                    result.description = "Source: ".concat(SOURCE_TITLE_MAP[item.raw.source] ? SOURCE_TITLE_MAP[item.raw.source] : item.raw.source);
                }
                if (item.isTopResult) {
                    result.description = 'Featured Article';
                }
            }
            else {
                var query = (_b = headlessSearchEngine.state.query) === null || _b === void 0 ? void 0 : _b.q;
                result.highlighterWords = query ? query.split(' ') : [''];
                var SourceIcon = ((_c = item.raw) === null || _c === void 0 ? void 0 : _c.source) && SOURCE_ICON_MAP[item.raw.source]
                    ? SOURCE_ICON_MAP[item.raw.source]
                    : SOURCE_ICON_MAP[TECH_DOCS_HELP_SOURCE];
                result.SourceIcon = SourceIcon;
            }
            var isReadableInternal = ((_d = item.raw) === null || _d === void 0 ? void 0 : _d.source) &&
                item.raw.source !== COMMUNITY_SOURCE &&
                item.raw.source !== COMMUNITY_SOURCE_DEV &&
                SOURCE_TITLE_MAP[item.raw.source];
            result.readExternal = !isReadableInternal;
            return result;
        });
    }, [list, headlessSearchEngine, mode]);
    return normalizedList;
};

var _path$9;
function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
function SvgSearch(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$9({
    width: 16,
    height: 16,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M16.077 13.844l-3.125-3.125c-.157-.125-.344-.219-.532-.219h-.5a6.516 6.516 0 001.375-4c0-3.563-2.937-6.5-6.5-6.5-3.593 0-6.5 2.938-6.5 6.5 0 3.594 2.907 6.5 6.5 6.5 1.5 0 2.875-.5 4-1.375v.531c0 .188.063.375.22.531l3.093 3.094c.312.313.781.313 1.062 0l.875-.875c.313-.281.313-.75.032-1.062zM6.795 10.5c-2.218 0-4-1.781-4-4 0-2.188 1.782-4 4-4 2.188 0 4 1.813 4 4 0 2.219-1.812 4-4 4z",
    fill: "#333"
  })));
}

var _path$8;
function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
function SvgSearchClear(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$8({
    width: 16,
    height: 16,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M8.295.25A7.749 7.749 0 00.545 8a7.749 7.749 0 007.75 7.75A7.749 7.749 0 0016.045 8 7.749 7.749 0 008.295.25zm3.781 9.813c.157.124.157.374 0 .53l-1.218 1.22c-.157.156-.407.156-.532 0L8.296 9.75l-2.063 2.063c-.125.156-.375.156-.531 0l-1.22-1.25c-.155-.126-.155-.376 0-.532L6.546 8 4.483 5.969c-.156-.125-.156-.375 0-.532l1.25-1.218c.125-.157.375-.157.531 0L8.295 6.25l2.031-2.031c.125-.157.375-.157.532 0l1.218 1.218c.157.157.157.407 0 .532L10.046 8l2.03 2.063z",
    fill: "#333"
  })));
}

var _path$7, _path2;
function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
function SvgArrRight(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$7({
    width: 16,
    height: 16,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 3.5a.25.25 0 01.25-.25h6.5A.25.25 0 017 3.5v1a.25.25 0 01-.25.25H.25A.25.25 0 010 4.5v-1z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M7.658 4.21a.27.27 0 000-.397L4.213.342c-.094-.116-.281-.116-.399 0l-.445.47c-.117.093-.117.28 0 .398L6.135 4 3.369 6.813a.27.27 0 000 .398l.445.469c.118.117.305.117.399 0l3.445-3.47z",
    fill: "#333"
  })));
}

var SearchBox = function (_a) {
    var _b, _c, _d, _e, _f;
    var engines = _a.engines, activeTab = _a.activeTab, onChangeTab = _a.onChangeTab, article = _a.article;
    var _g = React.useState(engines.headlessSearchBox.state), state = _g[0], setState = _g[1];
    var _h = React.useState(engines.headlessQuerySummary.state), querySummary = _h[0], setQuerySummary = _h[1];
    var _j = React.useState(false), suggestionsState = _j[0], setSuggestionsState = _j[1];
    var goTo = useHCActions().goTo;
    var _k = useHCCtx(), isFullscreenMode = _k.isFullscreenMode, onSetFullscreenMode = _k.onSetFullscreenMode;
    var theme = useThemeCtx().theme;
    var handleInputKeyDown = React.useCallback(function (e) {
        if (e.key === 'Enter') {
            engines.headlessSearchBox.submit();
            setSuggestionsState(false);
            goTo({ view: VIEWS.RESULTS });
        }
    }, [setSuggestionsState, state.value, isFullscreenMode]);
    var handleInputChange = React.useCallback(function (e) {
        setSuggestionsState(true);
        engines.headlessSearchBox.updateText(e.target.value);
    }, []);
    var handleClickInputBtn = React.useCallback(function () {
        engines.headlessSearchBox.selectSuggestion('');
        if (state.value && !isFullscreenMode) {
            goTo({ view: VIEWS.HOME });
        }
        Emitter.emit('leaveArticleView', article);
    }, [state.value, isFullscreenMode]);
    var handleBtnClick = React.useCallback(function () {
        engines.headlessSearchBox.selectSuggestion(state.value);
        setSuggestionsState(false);
        onSetFullscreenMode();
        Emitter.emit('allResultsOpen');
    }, [state.value]);
    var handleClickSuggestion = React.useCallback(function (value) {
        engines.headlessSearchBox.selectSuggestion(value);
        setSuggestionsState(false);
        goTo({ view: VIEWS.RESULTS });
        Emitter.emit('suggestionSelect', value);
    }, []);
    React.useEffect(function () {
        return engines.headlessSearchBox.subscribe(function () {
            setState(engines.headlessSearchBox.state);
        });
    }, []);
    React.useEffect(function () {
        return engines.headlessQuerySummary.subscribe(function () {
            setQuerySummary(engines.headlessQuerySummary.state);
        });
    }, []);
    return (React__default["default"].createElement("div", { className: cn__default["default"](styles$c.box, (_b = {}, _b[styles$c.advanced] = isFullscreenMode, _b), styles$c[theme]), "aria-label": "search-box-container", test_id: "ch-search-box" },
        React__default["default"].createElement("div", { className: cn__default["default"](styles$c['input-wrapper'], (_c = {}, _c[styles$c.advanced] = isFullscreenMode, _c)), "aria-label": "search-box-input-wrapper", test_id: "ch-search-box-input-wrapper" },
            React__default["default"].createElement("input", { value: state.value, onChange: handleInputChange, onKeyDown: handleInputKeyDown, className: cn__default["default"](styles$c.input, (_d = {}, _d[styles$c.advanced] = isFullscreenMode, _d)), "aria-label": "search-box-input", test_id: "ch-search-box-input", placeholder: _T('Search for more...') }),
            React__default["default"].createElement("div", { className: cn__default["default"](styles$c['input-button'], (_e = {},
                    _e[styles$c['is-interactive']] = state.value,
                    _e[styles$c.advanced] = isFullscreenMode,
                    _e)), "aria-label": "search-box-input-btn", test_id: "ch-search-box-input-btn", onClick: handleClickInputBtn }, state.value ? React__default["default"].createElement(SvgSearchClear, null) : React__default["default"].createElement(SvgSearch, null)),
            isFullscreenMode && (React__default["default"].createElement("div", { className: cn__default["default"](styles$c['search-box-submit-btn'], (_f = {},
                    _f[styles$c['is-interactive']] = state.value,
                    _f)), "aria-label": "search-box-submit-btn", onClick: function () { return handleClickSuggestion(state.value); } },
                React__default["default"].createElement(SvgArrRight, null))),
            isFullscreenMode && (React__default["default"].createElement("span", { className: styles$c.info, "aria-label": "search-box-info" },
                _T('Results'),
                ' ',
                React__default["default"].createElement("strong", null,
                    querySummary.firstResult,
                    "-",
                    querySummary.lastResult),
                ' ',
                _T('of'),
                " ",
                React__default["default"].createElement("strong", null, querySummary.total),
                " in",
                ' ',
                React__default["default"].createElement("strong", null, querySummary.durationInSeconds),
                " ",
                _T('seconds')))),
        isFullscreenMode && React__default["default"].createElement(Tabs$1, { activeTab: activeTab, onChangeTab: onChangeTab }),
        state.value && suggestionsState && (React__default["default"].createElement("div", { className: styles$c.suggestions, "aria-label": "search-box-suggestions", test_id: "ch-search-box-suggestions" },
            React__default["default"].createElement("ul", { className: styles$c['suggestions-list'], "aria-label": "search-box-suggestions-list", test_id: "ch-search-box-suggestions-list" }, state.suggestions.map(function (suggestion) {
                var value = suggestion.rawValue;
                return (React__default["default"].createElement("li", { key: value, onClick: function () { return handleClickSuggestion(value); }, className: styles$c['suggestions-list-item'], "aria-label": "search-box-suggestions-list-item", test_id: "ch-search-box-suggestions-list-item" }, value));
            })),
            React__default["default"].createElement("div", { className: styles$c.button, onClick: handleBtnClick, "aria-label": "search-box-all-results-button", test_id: "ch-search-box-btn-all-results" },
                React__default["default"].createElement("span", null, _T('Show all search results')))))));
};
var SearchBox$1 = React.memo(SearchBox);

var _path$6;
function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
function SvgClose(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$6({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M7.617 5.75l2.735-2.734a.812.812 0 000-1.204l-.602-.601a.812.812 0 00-1.203 0L5.812 3.945 3.051 1.211a.812.812 0 00-1.203 0l-.602.601a.812.812 0 000 1.204L3.98 5.75 1.246 8.512a.812.812 0 000 1.203l.602.601a.812.812 0 001.203 0l2.761-2.734 2.735 2.734a.812.812 0 001.203 0l.602-.601a.812.812 0 000-1.203L7.617 5.75z",
    fill: "#333"
  })));
}

var _path$5;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
function SvgCompress(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$5({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M11.922 5a.333.333 0 00.328-.328V3.578a.353.353 0 00-.328-.328H9.625V.953a.353.353 0 00-.328-.328H8.203a.332.332 0 00-.328.328v3.39c0 .384.273.657.656.657h3.39zm-7.547-.656V.954a.353.353 0 00-.328-.329H2.953a.332.332 0 00-.328.328V3.25H.328A.332.332 0 000 3.578v1.094C0 4.863.137 5 .328 5h3.39a.648.648 0 00.657-.656zm0 8.203v-3.39c0-.356-.3-.657-.656-.657H.329A.332.332 0 000 8.828v1.094c0 .191.137.328.328.328h2.297v2.297c0 .191.137.328.328.328h1.094a.332.332 0 00.328-.328zm5.25 0V10.25h2.297a.332.332 0 00.328-.328V8.828a.353.353 0 00-.328-.328h-3.39c-.384 0-.657.3-.657.656v3.39c0 .192.137.329.328.329h1.094a.332.332 0 00.328-.328z",
    fill: "#333"
  })));
}

var _path$4;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
function SvgExpand(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$4({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 4.672C0 4.863.137 5 .328 5h1.094a.332.332 0 00.328-.328V2.375h2.297a.332.332 0 00.328-.328V.953a.353.353 0 00-.328-.328H.657c-.384 0-.657.3-.657.656v3.39zM7.875.953v1.094c0 .191.137.328.328.328H10.5v2.297c0 .191.137.328.328.328h1.094a.333.333 0 00.328-.328v-3.39c0-.356-.3-.657-.656-.657h-3.39a.332.332 0 00-.329.328zM11.922 8.5h-1.094a.332.332 0 00-.328.328v2.297H8.203a.333.333 0 00-.328.328v1.094c0 .191.137.328.328.328h3.39a.648.648 0 00.657-.656v-3.39a.353.353 0 00-.328-.329zm-7.547 4.047v-1.094a.353.353 0 00-.328-.328H1.75V8.828a.353.353 0 00-.328-.328H.328A.332.332 0 000 8.828v3.39c0 .384.273.657.656.657h3.39a.332.332 0 00.329-.328z",
    fill: "#333"
  })));
}

var styles$b = {"wrapper":"Header-module_wrapper__eb-7V","dark":"Header-module_dark__F69nP","light":"Header-module_light__y3ChA","advanced":"Header-module_advanced__xC1U0","title":"Header-module_title__OVi-I","description":"Header-module_description__zquBb","buttons":"Header-module_buttons__sdyon","btn":"Header-module_btn__NoPcs","view-btn":"Header-module_view-btn__PlTh9","view-close":"Header-module_view-close__08Ek-"};

var Header = function () {
    var _a;
    var _b = useHCCtx(), isFullscreenMode = _b.isFullscreenMode, onSetDefaultMode = _b.onSetDefaultMode, onSetFullscreenMode = _b.onSetFullscreenMode, mode = _b.mode;
    var theme = useThemeCtx().theme;
    var handleChangeModeClick = React.useCallback(function () {
        if (isFullscreenMode) {
            onSetDefaultMode();
        }
        else {
            onSetFullscreenMode();
        }
    }, [isFullscreenMode, mode, onSetDefaultMode, onSetFullscreenMode]);
    var handleCloseBtnClick = React.useCallback(function () {
        Emitter.emit('close');
    }, []);
    return (React__default["default"].createElement("div", { className: cn__default["default"](styles$b.wrapper, (_a = {}, _a[styles$b.advanced] = isFullscreenMode, _a), styles$b[theme]), test_id: "ch-header", "aria-label": "header-container" },
        React__default["default"].createElement("div", { test_id: "ch-header-title" },
            !isFullscreenMode && (React__default["default"].createElement("h2", { className: styles$b.title, "aria-label": "header-title-default" }, _T('Knowledge Center'))),
            isFullscreenMode && (React__default["default"].createElement(React__default["default"].Fragment, null,
                React__default["default"].createElement("h2", { className: styles$b.title, "aria-label": "header-title-fullscreen" }, _T('Expanded Search')),
                React__default["default"].createElement("div", { className: styles$b.description, "aria-label": "header-description", test_id: "ch-header-description" }, _T('Find the answers you’re looking for across all the resources Palo Alto Networks provides.'))))),
        React__default["default"].createElement("div", { className: styles$b.buttons, test_id: "ch-header-btns" },
            React__default["default"].createElement("div", { className: cn__default["default"](styles$b.btn, styles$b['view-btn'], styles$b[theme]), test_id: "ch-change-view-btn", "aria-label": "change-mode-btn", onClick: handleChangeModeClick }, isFullscreenMode ? (React__default["default"].createElement(SvgCompress, { "aria-label": "header-compress-icon" })) : (React__default["default"].createElement(SvgExpand, { "aria-label": "header-expand-icon" }))),
            React__default["default"].createElement("div", { className: cn__default["default"](styles$b.btn, styles$b['view-close'], styles$b[theme]), test_id: "ch-close-btn", "aria-label": "close-btn", onClick: handleCloseBtnClick },
                React__default["default"].createElement(SvgClose, { "aria-label": "header-close-icon" })))));
};
var Header$1 = React.memo(Header);

var styles$a = {"container":"HomeView-module_container__nGZSc"};

var _path$3;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
function SvgLink(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$3({
    width: 16,
    height: 16,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M13.5 10h-1c-.281 0-.5.25-.5.5V14H2V4h4.5c.25 0 .5-.219.5-.5v-1c0-.25-.25-.5-.5-.5h-5A1.5 1.5 0 000 3.5v11c0 .844.656 1.5 1.5 1.5h11a1.5 1.5 0 001.5-1.5v-4c0-.25-.25-.5-.5-.5zm1.75-10h-4c-.688 0-1.031.813-.531 1.281l1.094 1.125-7.594 7.625c-.125.125-.25.344-.25.531 0 .157.125.407.25.532l.687.687c.125.125.375.25.532.25.187 0 .406-.125.53-.25l7.626-7.594 1.125 1.094C15.188 5.75 16 5.438 16 4.75v-4a.76.76 0 00-.75-.75z",
    fill: "#333"
  })));
}

var styles$9 = {"container":"Layout-module_container__nOaUb","dark":"Layout-module_dark__dhwjs","light":"Layout-module_light__jjzHd","icon":"Layout-module_icon__3RbdK","content":"Layout-module_content__EMp7e","title":"Layout-module_title__BZxiB","list":"Layout-module_list__JX23Z","link":"Layout-module_link__RXqpW","link-text":"Layout-module_link-text__jixa8"};

var Layout = React.forwardRef(function (_a, ref) {
    var icon = _a.icon, title = _a.title, content = _a.content, link = _a.link, className = _a.className, onScroll = _a.onScroll, restProps = __rest(_a, ["icon", "title", "content", "link", "className", "onScroll"]);
    var theme = useThemeCtx().theme;
    var handleScroll = React.useCallback(function (e) {
        if (onScroll) {
            onScroll(e.target);
        }
    }, [onScroll]);
    return (React__default["default"].createElement("div", { className: cn__default["default"](styles$9.container, className, styles$9[theme]), ref: ref, "aria-label": "layout-container", test_id: restProps.test_id || 'ch-layout-container', onScroll: handleScroll },
        icon && (React__default["default"].createElement("span", { "aria-label": "layout-icon", className: styles$9.icon, test_id: "icon" }, icon)),
        React__default["default"].createElement("div", { className: styles$9.content, test_id: "ch-layout-content" },
            title && (React__default["default"].createElement("div", { className: styles$9.title, "aria-label": "layout-title", test_id: "title" }, title)),
            content && (React__default["default"].createElement("div", { className: styles$9.list, test_id: "list", "aria-label": "layout-content" }, content)),
            link && (React__default["default"].createElement("div", { className: styles$9.link, test_id: "link-container" },
                React__default["default"].createElement("span", { className: styles$9['link-text'], test_id: "link-description", "aria-label": "layout-link", onClick: link.handleClick }, link.text),
                link.showIcon && React__default["default"].createElement(SvgLink, null))))));
});
var Layout$1 = React.memo(Layout);

var styles$8 = {"container":"ListItem-module_container__B-Q5-","advanced":"ListItem-module_advanced__bACkx","card-view":"ListItem-module_card-view__PeiKC","light":"ListItem-module_light__iF0pI","dark":"ListItem-module_dark__PrxSZ","body":"ListItem-module_body__WDwr0","link":"ListItem-module_link__goKG5","description":"ListItem-module_description__a3QP8","icon":"ListItem-module_icon__Qlzgd","highlighter":"ListItem-module_highlighter__fsQKn"};

var ListItem = function (_a) {
    var _b, _c, _d, _e;
    var item = _a.item, onClickItem = _a.onClickItem, engine = _a.engine, _f = _a.showListItemDescription, showListItemDescription = _f === void 0 ? true : _f, _g = _a.showListItemIcon, showListItemIcon = _g === void 0 ? true : _g, _h = _a.itemViewType, itemViewType = _h === void 0 ? RESULT_LIST_VIEW.LIST : _h;
    var isFullscreenMode = useHCCtx().isFullscreenMode;
    var theme = useThemeCtx().theme;
    var isCardModeInFullScreen = isFullscreenMode && itemViewType === RESULT_LIST_VIEW.CARD;
    var interactiveResult = React.useMemo(function () {
        if (!engine)
            return null;
        return headless.buildInteractiveResult(engine, {
            options: { result: item },
        });
    }, [engine, item]);
    var onFireInteractiveResultAction = React.useCallback(function (type) {
        if (!interactiveResult)
            return;
        interactiveResult[type]();
    }, [interactiveResult]);
    var handleClick = React.useCallback(function (e) {
        if (!e.currentTarget.getAttribute('target')) {
            e.preventDefault();
            onFireInteractiveResultAction('select');
            onClickItem(item);
        }
    }, [interactiveResult, onClickItem, item]);
    React.useEffect(function () { return function () { return onFireInteractiveResultAction('cancelPendingSelect'); }; }, [interactiveResult]);
    return (React__default["default"].createElement("li", { className: cn__default["default"](styles$8.container, styles$8[theme], (_b = {},
            _b[styles$8.advanced] = isFullscreenMode,
            _b[styles$8['card-view']] = isCardModeInFullScreen,
            _b)), "aria-label": "list-item-container", test_id: "ch-list-item" },
        showListItemIcon && item.SourceIcon && (React__default["default"].createElement("div", { className: cn__default["default"](styles$8.icon, (_c = {}, _c[styles$8['card-view']] = isCardModeInFullScreen, _c)), "aria-label": "list-item-source-icon" },
            React__default["default"].createElement(item.SourceIcon, null))),
        React__default["default"].createElement("div", { className: cn__default["default"](styles$8.body, (_d = {}, _d[styles$8['card-view']] = isCardModeInFullScreen, _d)), "aria-label": "list-item-body" },
            React__default["default"].createElement("a", __assign({}, (item.readExternal && { target: '_blank' }), { href: filterProtocol(item.clickUri), test_id: "ch-list-item-link", "aria-label": "list-item-link", className: styles$8.link, onClick: handleClick, onContextMenu: function () { return onFireInteractiveResultAction('select'); }, onMouseDown: function () { return onFireInteractiveResultAction('select'); }, onMouseUp: function () { return onFireInteractiveResultAction('select'); }, onTouchStart: function () { return onFireInteractiveResultAction('beginDelayedSelect'); }, onTouchEnd: function () { return onFireInteractiveResultAction('cancelPendingSelect'); } }),
                React__default["default"].createElement("span", { className: styles$8.title }, item.title)),
            showListItemDescription && (React__default["default"].createElement("div", { className: cn__default["default"](styles$8.description, (_e = {},
                    _e[styles$8.advanced] = isFullscreenMode,
                    _e[styles$8['card-view']] = isCardModeInFullScreen,
                    _e)), "aria-label": "list-item-description", test_id: "ch-list-item-description" },
                item.description,
                item.highlighterWords && (React__default["default"].createElement(Highlighter__default["default"], { highlightClassName: styles$8.highlighter, searchWords: item.highlighterWords, autoEscape: true, textToHighlight: item.excerpt })))))));
};
var ListItem$1 = React.memo(ListItem);

var styles$7 = {"container":"List-module_container__I7hMh","list-empty":"List-module_list-empty__t3wUy","dark":"List-module_dark__Xo3Wz","light":"List-module_light__e5LtY"};

var List = function (_a) {
    var _b = _a.emptyMsg, emptyMsg = _b === void 0 ? '' : _b, list = _a.list, engine = _a.engine, showListItemDescription = _a.showListItemDescription, showListItemIcon = _a.showListItemIcon, itemViewType = _a.itemViewType, onClickListItem = _a.onClickListItem;
    var theme = useThemeCtx().theme;
    if (emptyMsg && !list.length) {
        return (React__default["default"].createElement("div", { className: cn__default["default"](styles$7['list-empty'], styles$7[theme]), "aria-label": "list-empty-message" },
            React__default["default"].createElement("span", null,
                React__default["default"].createElement("i", null, emptyMsg))));
    }
    return (React__default["default"].createElement("ul", { className: styles$7.container, "aria-label": "list-container", test_id: "ch-list" }, list.map(function (item) { return (React__default["default"].createElement(ListItem$1, __assign({ item: item, key: item.uniqueId, itemViewType: itemViewType, showListItemDescription: showListItemDescription, showListItemIcon: showListItemIcon, onClickItem: onClickListItem }, (engine && { engine: engine })))); })));
};
var List$1 = React.memo(List);

var _path$2;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
function SvgLoading(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7-63.1 26.8-130.2 40.3-199.3 40.3z",
    fill: "#0ba4e8"
  })));
}

var styles$6 = {"container":"Loader-module_container__FieQ6","spinner":"Loader-module_spinner__xG6h2","loading":"Loader-module_loading__IxD4W"};

var Loader = function () { return (React__default["default"].createElement("div", { className: cn__default["default"](styles$6.container), test_id: "loading-container", "aria-label": "loading-container" },
    React__default["default"].createElement("div", { className: styles$6.spinner },
        React__default["default"].createElement(SvgLoading, null)))); };
var Loader$1 = React.memo(Loader);

var styles$5 = {};

var Recommendations = function (_a) {
    var _b = _a.engines, headlessRecommendationList = _b.headlessRecommendationList, headlessSearchEngine = _b.headlessSearchEngine, headlessRecommendationEngine = _b.headlessRecommendationEngine, maxCountItems = _a.maxCountItems, showListItemDescription = _a.showListItemDescription, showListItemIcon = _a.showListItemIcon;
    var _c = React.useState(headlessRecommendationList.state), state = _c[0], setState = _c[1];
    var openArticle = useHCActions().openArticle;
    var handleClickListItem = React.useCallback(function (val) {
        openArticle(val);
        var logRecommendationOpen = recommendation.loadClickAnalyticsActions(headlessRecommendationEngine).logRecommendationOpen;
        headlessRecommendationEngine.dispatch(logRecommendationOpen(val));
        Emitter.emit('recommendationSelect', val);
    }, []);
    React.useEffect(function () {
        var unsubscribeFn = headlessRecommendationList.subscribe(function () {
            setState(headlessRecommendationList.state);
        });
        return unsubscribeFn;
    }, []);
    var normalizedList = useNormalizedList({
        list: state.recommendations,
        headlessSearchEngine: headlessSearchEngine,
    });
    var resultsList = maxCountItems ? normalizedList.slice(0, maxCountItems) : normalizedList;
    return (React__default["default"].createElement("div", { className: styles$5.container, "aria-label": "recommendations-container", test_id: "ch-recommendations" }, state.isLoading ? (React__default["default"].createElement(Loader$1, null)) : (React__default["default"].createElement(List$1, { emptyMsg: _T("Type what you're looking for into the search field above."), list: resultsList, onClickListItem: handleClickListItem, showListItemDescription: showListItemDescription, showListItemIcon: showListItemIcon }))));
};
var Recommendations$1 = React.memo(Recommendations);

var _path$1;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
function SvgWalkthrough(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1({
    width: 16,
    height: 16,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M7 3a1.5 1.5 0 001.5-1.5C8.5.687 7.812 0 7 0a1.5 1.5 0 00-1.5 1.5C5.5 2.344 6.156 3 7 3zm2.938 4.688l-.72-.375-.312-.938C8.437 5 7.156 4.031 5.72 4c-1.125 0-1.75.344-2.907.813-.687.25-1.25.78-1.562 1.437l-.219.406C.781 7.156 1 7.75 1.47 8a.99.99 0 001.343-.438l.22-.437a.92.92 0 01.5-.469l.843-.343-.469 1.906c-.187.656 0 1.344.469 1.844l1.844 2.03c.25.25.406.563.468.876l.594 2.281c.125.531.657.875 1.188.719a.973.973 0 00.75-1.188L8.53 12a2.154 2.154 0 00-.469-.875L6.625 9.562l.531-2.124.188.5c.156.5.531.906 1 1.156l.719.375c.468.25 1.062.031 1.312-.438.25-.5.063-1.125-.438-1.344zM2.78 12.063c-.094.25-.25.5-.437.687L.78 14.313a.964.964 0 000 1.406.964.964 0 001.406 0l1.876-1.844c.187-.188.312-.438.437-.688l.406-1.062c-1.718-1.875-1.187-1.281-1.468-1.656l-.657 1.594z",
    fill: "#333"
  })));
}

var styles$4 = {"list":"Walkthrough-module_list__fXCsd","list-item":"Walkthrough-module_list-item__4FwLp","dark":"Walkthrough-module_dark__YCUaj","light":"Walkthrough-module_light__zrn3S","item":"Walkthrough-module_item__F69Ib"};

var WalkthroughList = function (_a) {
    var guides = _a.guides;
    var handleLickClick = React.useCallback(function (event, guide) {
        event.preventDefault();
        Emitter.emit('walkthroughOpen');
        guide === null || guide === void 0 ? void 0 : guide.launch();
    }, []);
    var theme = useThemeCtx().theme;
    return (React__default["default"].createElement("ul", { className: cn__default["default"](styles$4.list, styles$4[theme]), "aria-label": "walkthrough-list" }, guides.map(function (guide) { return (React__default["default"].createElement("li", { key: guide.id, "aria-label": "guide-".concat(guide.id), className: styles$4.item, test_id: "walkthrough-container-list-item" },
        React__default["default"].createElement("a", { href: "?".concat(guide.id), "aria-label": "guide-".concat(guide.id, "-link"), onClick: function (event) { return handleLickClick(event, guide); } }, guide.name))); })));
};
var Walkthrough = function (_a) {
    var _b;
    var guides = _a.guides;
    // eslint-disable-next-line no-console
    console.log('guides from repo - before filtering:', guides);
    var guidesAfterFilter = (_b = guides === null || guides === void 0 ? void 0 : guides.filter(function (g) { return g.name !== 'Submit Feature Request' && g.name !== 'Troubleshoot: Report an Issue'; })) !== null && _b !== void 0 ? _b : [];
    // eslint-disable-next-line no-console
    console.log('guides from repo - after filtering:', guides);
    return (React__default["default"].createElement(Layout$1, { icon: React__default["default"].createElement(SvgWalkthrough, null), title: _T('Related Walkthroughs'), content: React__default["default"].createElement(WalkthroughList, { guides: guidesAfterFilter }) }));
};
var Walkthrough$1 = React.memo(Walkthrough);

var Home = function (_a) {
    var engines = _a.engines, guides = _a.guides;
    var onSetFullscreenMode = useHCCtx().onSetFullscreenMode;
    var handleLayoutLinkClick = React.useCallback(function () {
        onSetFullscreenMode();
        Emitter.emit('allResultsOpen');
    }, []);
    return (React__default["default"].createElement("div", { className: styles$a.container, test_id: "main-view-container" },
        guides && guides.length > 0 && React__default["default"].createElement(Walkthrough$1, { guides: guides }),
        React__default["default"].createElement(Layout$1, { icon: React__default["default"].createElement(SvgTechDoc, null), title: _T('Recommendations'), content: React__default["default"].createElement(Recommendations$1, { engines: engines, maxCountItems: 6 }), link: {
                text: _T('Advanced search'),
                handleClick: handleLayoutLinkClick,
            } })));
};
var HomeView = React.memo(Home);

var styles$3 = {"container":"ResultsView-module_container__ZiTbm","card-view":"ResultsView-module_card-view__0rZSe"};

var ResultsView = function (_a) {
    var _b;
    var _c = _a.engines, headlessResultList = _c.headlessResultList, headlessSearchEngine = _c.headlessSearchEngine, headlessSearchBox = _c.headlessSearchBox, maxCountItems = _a.maxCountItems, listItemViewType = _a.listItemViewType;
    var _d = React.useState(headlessResultList.state), state = _d[0], setState = _d[1];
    var _e = useHCCtx(), isFullscreenMode = _e.isFullscreenMode, onSetFullscreenMode = _e.onSetFullscreenMode;
    var openArticle = useHCActions().openArticle;
    var handleClickListItem = React.useCallback(function (val) {
        openArticle(val);
        Emitter.emit('resultSelect', val);
        var interactiveResult = headless.buildInteractiveResult(headlessSearchEngine, {
            options: { result: val },
        });
        interactiveResult.select();
    }, []);
    var handleLayoutLinkClick = React.useCallback(function () {
        onSetFullscreenMode();
        Emitter.emit('allResultsOpen');
    }, []);
    var onFetchMore = React.useCallback(function (element) {
        if (isFullscreenMode && element.scrollTop >= element.scrollHeight - element.clientHeight) {
            headlessResultList.fetchMoreResults();
        }
    }, [headlessResultList, isFullscreenMode]);
    React.useEffect(function () {
        var unsubscribe = headlessResultList.subscribe(function () { return setState(headlessResultList.state); });
        if (!headlessSearchBox.state.value) {
            headlessSearchBox.submit();
        }
        return unsubscribe;
    }, []);
    var normalizedList = useNormalizedList({ list: state.results, headlessSearchEngine: headlessSearchEngine });
    var resultsList = maxCountItems ? normalizedList.slice(0, maxCountItems) : normalizedList;
    var isCardModeInFullScreen = isFullscreenMode && listItemViewType === RESULT_LIST_VIEW.CARD;
    return (React__default["default"].createElement(Layout$1, __assign({}, (!isFullscreenMode && {
        title: _T('Search results'),
        icon: React__default["default"].createElement(SvgSearch, { "aria-label": "results-view-search-icon" }),
    }), { content: state.isLoading && !isFullscreenMode ? (React__default["default"].createElement(Loader$1, null)) : (React__default["default"].createElement(List$1, { emptyMsg: _T('There’s no topics on this'), list: resultsList, onClickListItem: handleClickListItem, itemViewType: listItemViewType })), test_id: "ch-results", className: cn__default["default"](styles$3.container, (_b = {},
            _b[styles$3['card-view']] = isCardModeInFullScreen,
            _b)), link: !isFullscreenMode
            ? {
                text: _T('Try a different search'),
                handleClick: handleLayoutLinkClick,
            }
            : undefined, onScroll: onFetchMore })));
};
var ResultsView$1 = React.memo(ResultsView);

var fetchCurrentArticle = function (_a) {
    var accessToken = _a.accessToken, organizationId = _a.organizationId, uniqueId = _a.uniqueId;
    var url = "https://platform.cloud.coveo.com/rest/search/v2/html?organizationId=".concat(organizationId, "&uniqueId=").concat(uniqueId);
    return fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: "Bearer ".concat(accessToken),
        },
    });
};

var decodeToHTMLString = function (htmlResponse) { return __awaiter(void 0, void 0, void 0, function () {
    var charset, contentType, match, buffer;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                charset = 'UTF-8';
                contentType = htmlResponse.headers.get('content-type');
                if (contentType) {
                    match = contentType.match(/(?:charset=)([\w\d-]+)/);
                    if (match)
                        charset = match[1];
                }
                return [4 /*yield*/, htmlResponse.arrayBuffer()];
            case 1:
                buffer = _a.sent();
                return [2 /*return*/, new TextDecoder(charset).decode(buffer)];
        }
    });
}); };
var parser = new DOMParser();
var CLASS_NAME_PREFIX = 'tech-doc-';
var CLASS_NAME_NO_LIGHTBOX = 'tech-doc-no-lightbox';
var KNOWLEDGE_BASE_ARTICLE_SELECTOR = 'body';
var TECH_DIC_ARTICLE_SELECTOR = '.book-pdf-content';
var PRISMA_CLOUD_DOCS_ARTICLE_SELECTOR = '.content-inner';
var parseHtmlString = function (_a) {
    var _b;
    var source = _a.source, htmlString = _a.htmlString, uri = _a.uri;
    var pathArray = uri.split('/');
    var protocol = pathArray[0];
    var host = pathArray[2];
    var baseUrl = "".concat(protocol, "//").concat(host);
    var doc = parser.parseFromString(htmlString, 'text/html');
    var rootSelector = TECH_DIC_ARTICLE_SELECTOR;
    if (source === SALESFORCE_SOURCE ||
        source === SALESFORCE_SOURCE_STAGE ||
        source === SALESFORCE_GCS_SOURCE) {
        rootSelector = KNOWLEDGE_BASE_ARTICLE_SELECTOR;
    }
    else if (source === PRISMA_CLOUD_DOCS_SOURCE ||
        source === PRISMA_CLOUD_DOCS_SOURCE_DEV) {
        rootSelector = PRISMA_CLOUD_DOCS_ARTICLE_SELECTOR;
    }
    var rootEl = doc.querySelector(rootSelector);
    if (rootEl) {
        var htmlCollection = rootEl.querySelectorAll('*');
        for (var i = 0; i < htmlCollection.length; i++) {
            var elNode = htmlCollection[i];
            var classNames_1 = elNode.getAttribute('class');
            var hrefStr = elNode.getAttribute('href');
            if (classNames_1) {
                classNames_1 = CLASS_NAME_PREFIX + classNames_1.replace(/ /g, " ".concat(CLASS_NAME_PREFIX));
                elNode.setAttribute('class', classNames_1);
            }
            if (hrefStr) {
                if (/^\//gm.test(hrefStr)) {
                    elNode.setAttribute('href', "".concat(baseUrl, "/").concat(hrefStr));
                }
                if (/^#|\?/gm.test(hrefStr)) {
                    elNode.setAttribute('href', "".concat(uri).concat(hrefStr));
                }
                elNode.setAttribute('target', "_blank");
            }
            if (elNode.tagName === 'IMG' && (classNames_1 === null || classNames_1 === void 0 ? void 0 : classNames_1.indexOf(CLASS_NAME_NO_LIGHTBOX)) === -1) {
                var imgWrapper = doc.createElement('div');
                imgWrapper.classList.add('tech-doc-img-wrapper');
                var imgSrc = elNode.getAttribute('src');
                if (imgSrc && /^\//gm.test(imgSrc)) {
                    elNode.setAttribute('src', "".concat(baseUrl).concat(imgSrc));
                }
                var clonedImg = elNode.cloneNode(true);
                var cloneImgSrc = clonedImg.getAttribute('src');
                imgWrapper.setAttribute('data-img-src', cloneImgSrc || '');
                imgWrapper.appendChild(clonedImg);
                (_b = elNode.parentNode) === null || _b === void 0 ? void 0 : _b.replaceChild(imgWrapper, elNode);
            }
        }
        var titleEl = rootEl.querySelector('.tech-doc-title');
        if (titleEl)
            titleEl.remove();
    }
    return rootEl || document.createElement('div');
};

var Portal = function (_a) {
    var isOpen = _a.isOpen, _b = _a.renderTo, renderTo = _b === void 0 ? document.body : _b, children = _a.children, restProps = __rest(_a, ["isOpen", "renderTo", "children"]);
    if (!isOpen)
        return null;
    return ReactDOM__default["default"].createPortal(React__default["default"].createElement("div", __assign({}, restProps), children), renderTo);
};

var styles$2 = {"wrapper":"Lightbox-module_wrapper__Er6fP","image":"Lightbox-module_image__qXlJ-","close":"Lightbox-module_close__P-Mv4","overlay":"Lightbox-module_overlay__WVRsc"};

var Lightbox = function (_a) {
    var imgSrc = _a.imgSrc, onClose = _a.onClose;
    return (React__default["default"].createElement(Portal, { isOpen: true, className: styles$2.wrapper },
        React__default["default"].createElement("div", { className: styles$2.image },
            React__default["default"].createElement("img", { src: imgSrc, "aria-label": "lightbox-image" })),
        React__default["default"].createElement("div", { className: styles$2.overlay, "aria-label": "lightbox-overlay", onClick: onClose }),
        React__default["default"].createElement("div", { className: styles$2.close, "aria-label": "lightbox-close-button", onClick: onClose },
            React__default["default"].createElement(SvgClose, null))));
};
var Lightbox$1 = React.memo(Lightbox);

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgArrLeft(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M.865 4.286c-.246.273-.247.684-.001.93l3.714 3.723c.273.274.683.275.93.002l.63-.601c.246-.273.246-.683 0-.93L3.49 4.754l2.656-2.621a.678.678 0 00.001-.93l-.628-.63c-.246-.246-.656-.247-.93 0L.866 4.285z",
    fill: "#333"
  })));
}

var styles$1 = {"container":"ArticleView-module_container__Qh3Kt","dark":"ArticleView-module_dark__1Vk2T","light":"ArticleView-module_light__aGncJ","back":"ArticleView-module_back__ToJnA","body":"ArticleView-module_body__4O9Im","link-container":"ArticleView-module_link-container__Fc3-t","recommendations":"ArticleView-module_recommendations__eWTlZ","suggested-recommendations":"ArticleView-module_suggested-recommendations__Ykh7U"};

var TECH_DOC_IMG_CLASS_NAME = 'tech-doc-img-wrapper';
var ArticleView = function (_a) {
    var article = _a.article, engines = _a.engines;
    var closeArticle = useHCActions().closeArticle;
    var theme = useThemeCtx().theme;
    var contentRef = React.createRef();
    var _b = React.useState(undefined), activeImage = _b[0], setActiveImage = _b[1];
    var _c = React.useState(null), error = _c[0], setError = _c[1];
    var handleArticleClick = React.useCallback(function (_a) {
        var target = _a.target;
        if (target.classList.contains(TECH_DOC_IMG_CLASS_NAME)) {
            setActiveImage(target.getAttribute('data-img-src'));
        }
    }, []);
    var handleCloseLightbox = React.useCallback(function () {
        setActiveImage(undefined);
    }, []);
    var handleBackButtonClick = React.useCallback(function () {
        closeArticle();
        Emitter.emit('leaveArticleView', article);
    }, []);
    var onInsertDomTreeToContentRef = React.useCallback(function (domTree) {
        var currentNode = contentRef === null || contentRef === void 0 ? void 0 : contentRef.current;
        if (!currentNode)
            return;
        currentNode.innerHTML = '';
        currentNode.appendChild(domTree);
    }, [contentRef]);
    React.useEffect(function () {
        var _a = engines.headlessSearchEngine.state.configuration, accessToken = _a.accessToken, organizationId = _a.organizationId;
        (function () {
            return __awaiter(this, void 0, void 0, function () {
                var res, htmlString, domTree;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 3, , 4]);
                            return [4 /*yield*/, fetchCurrentArticle({
                                    accessToken: accessToken,
                                    organizationId: organizationId,
                                    uniqueId: article.uniqueId,
                                })];
                        case 1:
                            res = _a.sent();
                            return [4 /*yield*/, decodeToHTMLString(res)];
                        case 2:
                            htmlString = _a.sent();
                            domTree = parseHtmlString({
                                source: article.raw.source,
                                htmlString: htmlString,
                                uri: article.uri,
                            });
                            onInsertDomTreeToContentRef(domTree);
                            return [3 /*break*/, 4];
                        case 3:
                            _a.sent();
                            setError({
                                type: 'Error',
                                msg: _T('Content loading error'),
                            });
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        })();
    }, [article]);
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("div", { className: cn__default["default"](styles$1.container, styles$1[theme]) },
            React__default["default"].createElement("div", { className: styles$1.back, "aria-label": "article-back-button", test_id: "ch-article-back", onClick: handleBackButtonClick },
                React__default["default"].createElement(SvgArrLeft, null),
                React__default["default"].createElement("span", null, article.title)),
            React__default["default"].createElement("div", { className: styles$1.body },
                error ? (React__default["default"].createElement("div", { className: styles$1.error, "aria-label": "article-error", test_id: "ch-article-error" },
                    React__default["default"].createElement("span", null, error.msg))) : (React__default["default"].createElement("article", { id: "ch-article", "aria-label": "article-body", test_id: "ch-article", ref: contentRef, onClick: handleArticleClick })),
                React__default["default"].createElement("div", { className: styles$1['link-container'], test_id: "ch-article-link" },
                    React__default["default"].createElement("a", { href: article.clickUri, target: "_blank", rel: "noreferrer", className: styles$1.link },
                        _T('Open in new tab'),
                        React__default["default"].createElement(SvgLink, { height: "13", width: "12", viewBox: "0 0 17 17" })))),
            React__default["default"].createElement("div", { className: cn__default["default"](styles$1.recommendations, styles$1['suggested-recommendations']) },
                React__default["default"].createElement("h5", null, _T('Suggested articles')),
                React__default["default"].createElement(Recommendations$1, { engines: engines, maxCountItems: 3, showListItemDescription: false, showListItemIcon: false }))),
        activeImage && React__default["default"].createElement(Lightbox$1, { imgSrc: activeImage || '', onClose: handleCloseLightbox })));
};
var ArticleView$1 = React.memo(ArticleView);

var styles = {"container":"App-module_container__kk8GW","fullscreen":"App-module_fullscreen__QRKzG","body":"App-module_body__96uxe","dark":"App-module_dark__hdJ64","light":"App-module_light__B3cvX"};

var App = React.forwardRef(function (_a, ref) {
    var _b;
    var showHeader = _a.showHeader, engines = _a.engines, guides = _a.guides;
    var currentView = useRouterCtx().currentView;
    var _c = useHCCtx(), currentArticle = _c.currentArticle, isFullscreenMode = _c.isFullscreenMode, onSetFullscreenMode = _c.onSetFullscreenMode, onSetDefaultMode = _c.onSetDefaultMode;
    var theme = useThemeCtx().theme;
    var _d = React.useState(RESULT_LIST_VIEW.LIST), resultListItemViewType = _d[0], setResultListItemViewType = _d[1];
    React.useImperativeHandle(ref, function () { return ({
        onSetFullscreenMode: onSetFullscreenMode,
        onSetDefaultMode: onSetDefaultMode,
    }); });
    React.useEffect(function () { return function () {
        engines.headlessSearchBox.clear();
    }; }, []);
    return (React__default["default"].createElement("div", { id: "hc-app", "data-testid": "hc-app", test_id: "hc-app", "aria-label": "hc-app", className: cn__default["default"]({ fullscreen: isFullscreenMode }) },
        React__default["default"].createElement("div", { test_id: "hc-app-container", className: cn__default["default"](styles.container, styles[theme], (_b = {}, _b[styles.fullscreen] = isFullscreenMode, _b)) },
            showHeader && React__default["default"].createElement(Header$1, null),
            React__default["default"].createElement("div", { className: styles.body },
                React__default["default"].createElement(SearchBox$1, { article: currentArticle, engines: engines, activeTab: resultListItemViewType, onChangeTab: setResultListItemViewType }),
                currentView === VIEWS.HOME && (React__default["default"].createElement(HomeView, { engines: engines, key: VIEWS.HOME, guides: guides })),
                currentView === VIEWS.RESULTS && (React__default["default"].createElement(ResultsView$1, { maxCountItems: !isFullscreenMode ? 7 : undefined, engines: engines, key: VIEWS.RESULTS, listItemViewType: resultListItemViewType })),
                currentView === VIEWS.ARTICLE && currentArticle && (React__default["default"].createElement(ArticleView$1, { article: currentArticle, engines: engines, key: VIEWS.ARTICLE }))))));
});
var App$1 = React.memo(App);

var WidgetRoot = React.forwardRef(function (_a, ref) {
    var _b = _a.showHeader, showHeader = _b === void 0 ? true : _b, engines = _a.engines, engineContextOptions = _a.engineContextOptions, _c = _a.show, show = _c === void 0 ? true : _c, guides = _a.guides, initialTheme = _a.initialTheme, initialMode = _a.initialMode, initialArticle = _a.initialArticle;
    React.useEffect(function () {
        engines.searchContext.set(engineContextOptions);
        engines.recommendationsContext.set(engineContextOptions);
        var setOriginLevel3 = recommendation.loadConfigurationActions(engines.headlessRecommendationEngine).setOriginLevel3;
        var getRecommendations = recommendation.loadRecommendationActions(engines.headlessRecommendationEngine).getRecommendations;
        engines.headlessRecommendationEngine.dispatch(setOriginLevel3({ originLevel3: engineContextOptions.referrer }));
        engines.headlessRecommendationEngine.dispatch(getRecommendations());
    }, [engineContextOptions, engines]);
    return (React__default["default"].createElement("div", { id: "hc-widget-root" }, show && (React__default["default"].createElement(HCThemeProvider, { initialTheme: initialTheme },
        React__default["default"].createElement(HCRouterProvider, { initialMode: initialMode, initialArticle: initialArticle },
            React__default["default"].createElement(HCProvider, { initialMode: initialMode, initialArticle: initialArticle },
                React__default["default"].createElement(App$1, { engines: engines, guides: guides, showHeader: showHeader, ref: ref })))))));
});
var Root = React.memo(WidgetRoot);

var defaultEngineContextOptions = {
    referrer: window.location.href,
    location_host: window.location.host,
    location_path: (window.location.pathname || '').replace(/\/$/, ''),
    location_search: (window.location.search || '').replace(/^\?/, ''),
    location_hash: (window.location.hash || '').replace(/^\?/, ''),
};
var initEngines = function (_a) {
    var organizationId = _a.organizationId, accessToken = _a.accessToken, searchSearchHub = _a.searchSearchHub, searchPipeline = _a.searchPipeline, recommendationsSearchHub = _a.recommendationsSearchHub, recommendationsPipeline = _a.recommendationsPipeline, _b = _a.numberOfResults, numberOfResults = _b === void 0 ? 15 : _b;
    var referrer = window.location.href;
    var headlessSearchEngine = headless.buildSearchEngine({
        configuration: {
            organizationId: organizationId,
            accessToken: accessToken,
            search: {
                searchHub: searchSearchHub,
                pipeline: searchPipeline,
            },
            analytics: {
                originLevel3: referrer,
                analyticsClientMiddleware: function (_, payload) {
                    payload.customData.referrer = referrer;
                    return payload;
                },
            },
        },
    });
    var headlessRecommendationEngine = recommendation.buildRecommendationEngine({
        configuration: {
            organizationId: organizationId,
            accessToken: accessToken,
            searchHub: recommendationsSearchHub,
            pipeline: recommendationsPipeline,
            analytics: {
                originLevel3: referrer,
                analyticsClientMiddleware: function (_, payload) {
                    payload.customData.referrer = referrer;
                    return payload;
                },
            },
        },
    });
    var headlessSearchBox = headless.buildSearchBox(headlessSearchEngine, {
        options: {
            enableQuerySyntax: true,
            highlightOptions: {
                notMatchDelimiters: {
                    open: '<strong>',
                    close: '</strong>',
                },
                correctionDelimiters: {
                    open: '<i>',
                    close: '</i>',
                },
            },
        },
    });
    var headlessResultList = headless.buildResultList(headlessSearchEngine, {
        options: {
            fieldsToInclude: ['date'],
        },
    });
    var headlessRecommendationList = recommendation.buildRecommendationList(headlessRecommendationEngine);
    var headlessQuerySummary = headless.buildQuerySummary(headlessSearchEngine);
    var headlessResultsPerPage = headless.buildResultsPerPage(headlessSearchEngine, {
        initialState: { numberOfResults: numberOfResults },
    });
    var searchContext = headless.buildContext(headlessSearchEngine);
    var recommendationsContext = recommendation.buildContext(headlessRecommendationEngine);
    searchContext.set(defaultEngineContextOptions);
    recommendationsContext.set(defaultEngineContextOptions);
    return {
        headlessResultsPerPage: headlessResultsPerPage,
        headlessQuerySummary: headlessQuerySummary,
        headlessRecommendationList: headlessRecommendationList,
        headlessResultList: headlessResultList,
        headlessSearchBox: headlessSearchBox,
        headlessRecommendationEngine: headlessRecommendationEngine,
        headlessSearchEngine: headlessSearchEngine,
        searchContext: searchContext,
        recommendationsContext: recommendationsContext,
    };
};

exports.EventEmitter = Emitter;
exports.HCRoot = Root;
exports.initEngines = initEngines;
